<template>
  <div v-if="instagramLinked==true">
    <div v-if="insightsLoaded == true">
      <div class="row">
        <div class="col-md-12">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
        </div>
      </div>
      <div class="row">
        <div></div>
        <div class="col-md-6">
          <h4 style="margin:0px;margin-top:25px;">@{{$route.params.instagram}} Instagram Performance</h4>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <div style="padding: 10px;float:left;">
                Starting
                <datepicker
                  v-model="pickerStart"
                  placeholder="Select Date:"
                  name="datStart"
                  input-class="calendar-input-analytics"
                  format="M/d/yy"
                  :use-utc="true"
                ></datepicker>
              </div>
              <div style="padding:10px;float:left;">
                Ending
                <datepicker
                  v-model="pickerEnd"
                  placeholder="Select Date:"
                  name="campaignStart"
                  input-class="calendar-input-analytics"
                  format="M/d/yy"
                  :use-utc="true"
                ></datepicker>
              </div>
              <div style="padding: 10px; margin-top:10px;float:left;">
                <p-button color="success" class="mr-4" @click="resetDates">Select</p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <chart-card
            :chart-data="insightChart.data"
            :chart-height="75"
            :chart-options="insightChart.options"
          >
            <template slot="header">
              <h5 class="card-title">Content seen {{impressionsTotal}} times</h5>
              <p class="card-category">Instagram Profile Performance</p>
              <div style="right:15px; top:10px; position:absolute; ">
                <div class="legend" style="float:left; ">
                  <i class="fa fa-circle" style="color:#f17e5d;"></i> Impressions
                </div>
                <div class="legend" style="float:left; margin-left: 20px; ">
                  <i class="fa fa-circle" style="color:#6bd098;"></i> Reach
                </div>
              </div>
            </template>

            <!-- <template slot="footer">
          <hr />
          <div class="stats">
            <i class="fa fa-history"></i> Updated 3 minutes ago
          </div>
            </template>-->
          </chart-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <card>
            <template slot="header">
              <p class="card-category">Follower Growth</p>
              <h5 class="card-title" v-if="followersTotal > 0">Gained {{followersTotal}} Followers</h5>
              <h5 class="card-title" v-else-if="followersTotal < 1">{{followersTotal}} Followers</h5>
            </template>
            <line-chart
              :labels="followerChart.labels"
              :height="75"
              :datasets="followerChart.datasets"
              :extra-options="followerChart.options"
            ></line-chart>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="profileVisitsChartLoaded == true">
          <card>
            <template slot="header">
              <h4 class="card-title">{{profileVisitsTotal}} Profile Visits</h4>
              <p class="category"></p>
            </template>
            <line-chart
              :labels="profileVisitsChart.labels"
              :height="75"
              :datasets="profileVisitsChart.datasets"
              :extra-options="profileVisitsChart.options"
            ></line-chart>
          </card>
        </div>
        <div class="col-md-6" v-if="websiteClicksChartLoaded == true">
          <card>
            <template slot="header">
              <h4 class="card-title">{{websiteClicksTotal}} Website Clicks</h4>
              <p class="category"></p>
            </template>
            <line-chart
              :labels="websiteClicksChart.labels"
              :height="75"
              :datasets="websiteClicksChart.datasets"
              :extra-options="websiteClicksChart.options"
            ></line-chart>
          </card>
        </div>
      </div>
      <div v-if="topPostList.length > 0">
        <div class="row" style="clear:both;">
          <div class="col-md-12">
            <div class="row" style="clear:both;">
              <div class="col-md-5">
                <h5
                  style="margin:0px; padding: 0px;"
                  class="analytics-section-title"
                >Content Performance</h5>
              </div>
              <div class="col-md-7">
                <p-button
                  type="info"
                  round
                  outline
                  size="sm"
                  style="margin:0px; float:right;"
                  @click="fullContentAnalyticsButton"
                >
                  FULL CONTENT REPORT
                  <i class="fas fa-angle-right"></i>
                </p-button>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fab fa-instagram"
              small-title="Posts"
              :title="postCount"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fas fa-chart-line"
              small-title="ER"
              :title="postEngagementRate"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-heart"
              small-title="Avg Likes"
              :title="postAvgLikes"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-comment"
              small-title="Avg Comments"
              :title="postAvgComments"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
        </div>
      </div>
      <div v-if="hashtagGeneralChart !== null">
        <div class="row" style="clear:both;">
          <div class="col-md-12">
            <div class="row" style="clear:both;">
              <div class="col-md-5">
                <h5
                  style="margin:0px; padding: 0px;"
                  class="analytics-section-title"
                >Hashtag Performance</h5>
              </div>
              <div class="col-md-7"></div>
            </div>
            <hr />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <card style="padding-bottom:35px;">
              <template slot="header">
                <p class="card-category">Hashtag Performance</p>
              </template>
              <apexchart
                width="445"
                type="bar"
                :options="hashtagGeneralChart.options"
                :series="hashtagGeneralChart.series"
              ></apexchart>
            </card>
          </div>
          <div class="col-md-6" v-if="hashtagRankedChart !== null">
            <card>
              <template slot="header">
                <p class="card-category">Top Ranked Hashtags</p>
              </template>
              <apexchart
                width="500"
                type="bar"
                :options="hashtagRankedChart.options"
                :series="hashtagRankedChart.series"
              ></apexchart>
            </card>
          </div>
        </div>
      </div>
      <div class="row" style="clear:both;">
        <div class="col-md-12">
          <div class="row" style="clear:both;">
            <div class="col-md-5">
              <h5
                id="demographic-section"
                style="margin:0px; padding: 0px;"
                class="analytics-section-title"
              >Demographic Details</h5>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="genderSummaryChart !== null">
          <card>
            <template slot="header">
              <p class="card-category">Followers by Gender</p>
            </template>
            <apexchart
              width="445"
              type="pie"
              :options="genderSummaryApex.options"
              :series="genderSummaryApex.options.series"
            ></apexchart>
          </card>
        </div>
        <div class="col-md-6" v-if="ageSummaryChart !== null">
          <card>
            <template slot="header">
              <p class="card-category">Followers by Age</p>
            </template>
            <apexchart
              width="500"
              type="bar"
              :options="ageSummaryApex.options"
              :series="ageSummaryApex.series"
            ></apexchart>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="countryChart !== null">
          <card>
            <div class="row">
              <div class="col-md-6">
                <div slot="header">
                  <p class="card-category">Followers by Country</p>
                </div>
                <div>
                  <GChart
                    :settings="{  packages: ['corechart', 'table', 'map', 'geochart'], mapsApiKey: 'AIzaSyBrpjYwFfW979atnhjWXiG7K5CQRE4rJzA'  }"
                    type="GeoChart"
                    :data="countryChart.data"
                    :options="countryChart.options"
                  />
                </div>
              </div>
              <div class="col-md-6" v-if="cityData !== null" style="padding-left: 25px;">
                <div slot="header">
                  <p class="card-category">Top Cities</p>
                </div>
                <el-table :data="cityData">
                  <el-table-column label="#" width="50px">
                    <template slot-scope="props">{{props.$index + 1}}.</template>
                  </el-table-column>
                  <el-table-column label="City" width="250px">
                    <template slot-scope="props">{{props.row.city}}, {{props.row['state/country']}}</template>
                  </el-table-column>
                  <el-table-column label="Followers" property="count" width="150px"></el-table-column>
                </el-table>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row" v-if="topPostList.length > 0">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header" style="padding-bottom:0px; margin-bottom:0px;">
              <div>
                <h5 class="title" style="padding-bottom:0px;  margin-bottom:0px;">Top Posts</h5>
                <hr />
              </div>

              <div style="top: 0px; right: 10px; position:absolute; ">
                <p-button
                  style="margin-top:15px;"
                  type="info"
                  @click="$router.push(`/instagram/content/${$route.params.instagram}`)"
                  size="sm"
                  outline
                  round
                >
                  view all
                  <i class="fas fa-angle-right"></i>
                </p-button>
              </div>
            </div>

            <div class="card-body">
              <div class="post-preview" v-for="post in topPostList" :key="post.post.shortcode">
                <span v-if="post.post.cached == true">
                  <img
                    :src="post.post.imageUrlCache"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.post.shortcode}`)"
                  />
                </span>
                <span v-else>
                  <img
                    :src="post.post.imageUrl"
                     @error="imageLoadCache(post.post.shortcode)"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.post.shortcode}`)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="mentionPostList.length >0">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header" style="padding-bottom:0px; margin-bottom:0px;">
              <div>
                <h5 class="title" style="padding-bottom:0px;  margin-bottom:0px;">Recent Tags</h5>
                <hr />
              </div>

              <div style="top: 0px; right: 10px; position:absolute; ">
                <p-button
                  style="margin-top:15px;"
                  type="info"
                  @click="$router.push(`/instagram/content/${activeInstagram}/?view=mentions`)"
                  size="sm"
                  outline
                  round
                >
                  view all
                  <i class="fas fa-angle-right"></i>
                </p-button>
              </div>
            </div>

            <div class="card-body">
              <div class="post-preview" v-for="post in mentionPostList" :key="post.shortcode">
                <span v-if="post.cached == true">
                  <img
                    :src="post.imageUrlCache"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
                <span v-else>
                  <img
                    :src="post.imageUrl"
                     @error="imageLoadCache(post.shortcode)"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="noInstagramAnalytics==true"
    >Analytics not loaded yet. Please check back in 24 hours.</div>
    <div v-else>
      <div class="lds-dual-ring"></div>
    </div>
  </div>

  <div v-else-if="instagramLinked==false">
    Please
    <a href="/account/active-instagram">connect Instagram</a> profile to access analytics.
  </div>
  <div v-else>
    <div class="lds-dual-ring"></div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import _ from "underscore";
import { mapGetters, mapActions } from "vuex";
import timeVars from "@/config/timeVars";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import LineChart from "@/components/UIComponents/Charts/LineChart";
import BarChart from "@/components/UIComponents/Charts/BarChart";
import PieChart from "@/components/UIComponents/Charts/PieChart";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";
import { VueDatamaps } from "vue-datamaps";
import VueApexCharts from "vue-apexcharts";
import { GChart } from "vue-google-charts";
import store from "@/store/index.js";
import Datepicker from "vuejs-datepicker";

import {
  fbGraphInstagramInsights,
  clientProfileReadApi,
  userLoadApi,
  fbGraphMentionPosts,
  instagramPostApi,
  fbGraphInstagramCheck,
  instagramProfileAnalyticsApi,
  instagramPostAnalyticsApi,
  userRelatedProfilesApi,
  instagramPostCacheApi
} from "@/config/appSettings";
const tooltipOptions = {
  tooltipFillColor: "rgba(0,0,0,0.5)",
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipFontSize: 14,
  tooltipFontStyle: "normal",
  tooltipFontColor: "#fff",
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipTitleFontSize: 14,
  tooltipTitleFontStyle: "bold",
  tooltipTitleFontColor: "#fff",
  tooltipYPadding: 6,
  tooltipXPadding: 6,
  tooltipCaretSize: 8,
  tooltipCornerRadius: 6,
  tooltipXOffset: 10
};

export default {
  name: "InstagramAnalytics",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    clientDetails: null,
    auth: null,
    getTime: null,
    insightChart: {},
    insightsLoaded: false,
    profileVisitsChart: {},
    followerChart: {},
    profileVisitsChartLoaded: false,
    websiteClicksChart: {},
    websiteClicksChartLoaded: false,
    websiteClicksTotal: 0,
    profileVisitsTotal: 0,
    impressionsTotal: 0,
    followersTotal: 0,
    reachTotal: 0,
    mentionsLoaded: false,
    mentionPostList: [],
    postList: [],
    loadingOverlay: false,
    loadingOverlayText: null,
    instagramLinked: null,
    genderSummary: null,
    genderSummaryChart: null,
    ageSummaryChart: null,
    ageSummaryApex: null,
    genderSummaryApex: null,
    countryChart: null,
    cityData: null,
    topPostList: [],
    analyticsData: null,
    postEngagementRate: null,
    postAvgLikes: null,
    postAvgComments: null,
    postCount: null,
    hashtagGeneralChart: null,
    hashtagRankedChart: null,
    activeInstagram: null,
    startDate: null,
    endDate: null,
    pickerStart: null,
    pickerEnd: null,
    noInstagramAnalytics: null
  }),
  components: {
    ChartCard,
    LineChart,
    BarChart,
    PieChart,
    VueDatamaps,
    apexchart: VueApexCharts,
    GChart,
    StatsCard,
    Datepicker
  },
  created: function() {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  methods: {
     async imageLoadCache(shortcode) {
      let postCacheUrl = `${instagramPostCacheApi}/?usertoken=${this.auth}&shortcode=${shortcode}`;
      console.log("POST CACHE:", postCacheUrl);
      let postCacheResponse = await axios.get(postCacheUrl);
      console.log(`LOADING ${shortcode}`, postCacheResponse.data);
    },
    async checkNoAuthProfiles() {
      try {
        if (this.isTeam == true) {
          //console.log("ACTIVE INSTAGRAM:", this.activeInstagram);
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${this.activeInstagram}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
          return;
        }
        // console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (
          this.relatedProfileStore !== null &&
          typeof this.relatedProfileStore !== "undefined"
        ) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          // console.log("RESETTING PROFILES:", this.relatedProfiles);
          this.relatedProfileList = this.relatedProfiles.map(x => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPostAnalytics() {
      let instagramPostAnalyticsUrl = `${instagramPostAnalyticsApi}/?instagram=${this.$route.params.instagram}&usertoken=${this.auth}&start=${this.startDate}&end=${this.endDate}`;
      console.log("POST INSIGHT URL: ", instagramPostAnalyticsUrl);
      let instagramPostAnalyticsResponse = await axios.get(
        instagramPostAnalyticsUrl
      );
      if (instagramPostAnalyticsResponse.data.success == true) {
        console.log(
          "POST ANALYTICS:",
          instagramPostAnalyticsResponse.data.result
        );
        let postAnalyticData = instagramPostAnalyticsResponse.data.result;
        if (
          typeof instagramPostAnalyticsResponse.data.result.topFeedPosts !==
          "undefined"
        ) {
          let topFeedPostList =
            instagramPostAnalyticsResponse.data.result.topFeedPosts;
          if (topFeedPostList.length > 0) {
            this.topPostList = topFeedPostList.slice(0, 7);

            if (postAnalyticData.postTypes.feed.summary.posts > 0) {
              this.postEngagementRate =
                (
                  postAnalyticData.postTypes.feed.summary.avgEngagementRate *
                  100
                ).toFixed(2) + "%";

              this.postAvgLikes = String(
                postAnalyticData.postTypes.feed.summary.avgLikes.toFixed()
              );
              this.postAvgComments = String(
                postAnalyticData.postTypes.feed.summary.avgComments.toFixed()
              );
            }

            this.postCount = String(postAnalyticData.postCount);

            // HASHTAG ANALYTICS

            try {
              if (postAnalyticData.hashtags.hashtagsUsed.length > 0) {
                this.hashtagGeneralChart = {};
                this.hashtagGeneralChart.options = {
                  chart: {
                    id: "Avg Hashtags",
                    toolbar: {
                      show: false
                    }
                  },
                  yaxis: {
                    labels: {
                      formatter: function(value) {
                        return value.toFixed(1);
                      }
                    },
                    tickAmount: 2
                  },
                  xaxis: {
                    categories: ["hashtags used", "hashtags ranked"]
                  },
                  plotOptions: {
                    bar: {
                      horizontal: false
                    }
                  },
                  dataLabels: {
                    enabled: false
                  }
                };
                this.hashtagGeneralChart.series = [
                  {
                    name: "average",
                    data: [
                      postAnalyticData.hashtags.avgUsed.toFixed(2),
                      postAnalyticData.hashtags.avgRanked.toFixed(2)
                    ]
                  }
                ];
                // SORT
                let rankedHashtags = _.sortBy(
                  postAnalyticData.hashtags.hashtagsRanked,
                  "count"
                ).reverse();

                rankedHashtags = rankedHashtags.slice(0, 5);

                let rankedHashtagLabels = rankedHashtags.map(x => {
                  return x.hashtag;
                });
                let rankedHashtagCounts = rankedHashtags.map(x => {
                  return x.count;
                });
                this.hashtagRankedChart = {};
                this.hashtagRankedChart.options = {
                  chart: {
                    id: "Ranked",
                    toolbar: {
                      show: false
                    }
                  },

                  yaxis: {},
                  xaxis: {
                    categories: rankedHashtagLabels,
                    tickAmount: 2,
                    allowDecimals: false,
                    formatter: function(value) {
                      return value.toFixed();
                    }
                  },
                  plotOptions: {
                    bar: {
                      horizontal: true
                    }
                  },
                  dataLabels: {
                    enabled: false
                  }
                };
                this.hashtagRankedChart.series = [
                  {
                    name: "total",
                    data: rankedHashtagCounts
                  }
                ];
              }
            } catch (err) {
              //console.log("ERROR", err);
            }
          }
        }
      }
    },
    async loadProfileAnalytics() {
      try {
        /*this.endDate = this.getTime.startOfDay;
        this.startDate =
          moment
            .unix(this.endDate)
            .utc()
            .subtract(7, "days") / 1000;*/

        //console.log("START DATE:", startDate);

        let instagramAnalyticsUrl = `${instagramProfileAnalyticsApi}/?instagram=${this.$route.params.instagram}&usertoken=${this.auth}&start=${this.startDate}&end=${this.endDate}`;
        //console.log("INSIGHT URL: ", instagramAnalyticsUrl);
        let instagramAnalyticsResponse = await axios.get(instagramAnalyticsUrl);
        if (instagramAnalyticsResponse.data.success == true) {
          /*console.log(
            "ANALYTICS RESPONSE: ",
            instagramAnalyticsResponse.data.result
          );*/
          this.analyticsData = instagramAnalyticsResponse.data.result;

          if (this.analyticsData.timeSeries.labels.length > 0) {
            this.cityData = _.sortBy(
              instagramAnalyticsResponse.data.result.demographics.audienceCity,
              "count"
            )
              .reverse()
              .slice(0, 10);
            this.loadingOverlay = false;

            let reachData = instagramAnalyticsResponse.data.result.timeSeries.reach.map(
              x => {
                return x.count;
              }
            );
            let reachLabels = instagramAnalyticsResponse.data.result.timeSeries.reach.map(
              x => {
                return x.dateString;
              }
            );
            this.reachTotal =
              instagramAnalyticsResponse.data.result.summary.reach;

            //console.log("REACH DATA: ", reachData);
            let impressionData = instagramAnalyticsResponse.data.result.timeSeries.impressions.map(
              x => {
                return x.count;
              }
            );
            //console.log("IMPRESSION DATA: ", impressionData);
            this.impressionsTotal =
              instagramAnalyticsResponse.data.result.summary.impressions;
            let websiteClickData = instagramAnalyticsResponse.data.result.timeSeries.websiteClicks.map(
              x => {
                return x.count;
              }
            );
            let websiteClickLabels = instagramAnalyticsResponse.data.result.timeSeries.websiteClicks.map(
              x => {
                return x.dateString;
              }
            );
            this.websiteClicksTotal =
              instagramAnalyticsResponse.data.result.summary.websiteClicks;
            //          console.log("WEBSITE CLICK DATA: ", websiteClickData);

            let profileVisitsData = instagramAnalyticsResponse.data.result.timeSeries.profileViews.map(
              x => {
                return x.count;
              }
            );
            let profileVisitsLabels = instagramAnalyticsResponse.data.result.timeSeries.profileViews.map(
              x => {
                return x.dateString;
              }
            );
            this.profileVisitsTotal =
              instagramAnalyticsResponse.data.result.summary.profileViews;

            let followerData = instagramAnalyticsResponse.data.result.timeSeries.followers.map(
              x => {
                return x.count;
              }
            );
            let followerLabels = instagramAnalyticsResponse.data.result.timeSeries.followers.map(
              x => {
                return x.dateString;
              }
            );

            this.followersTotal =
              instagramAnalyticsResponse.data.result.summary.followers;

            //        console.log("WEBSITE CLICK DATA: ", profileVisitsData);

            this.insightChart = {
              data: {
                labels: reachLabels,
                datasets: [
                  {
                    label: "Reach",
                    borderColor: "#6bd098",
                    backgroundColor: "#6bd098",
                    pointRadius: 2,
                    pointHoverRadius: 2,
                    borderWidth: 3,
                    data: reachData
                  },
                  {
                    label: "Impressions",
                    borderColor: "#f17e5d",
                    backgroundColor: "#f17e5d",
                    pointRadius: 2,
                    pointHoverRadius: 2,
                    borderWidth: 3,
                    data: impressionData
                  }
                ]
              },
              options: {
                tooltips: tooltipOptions,
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        fontColor: "#9f9f9f",
                        beginAtZero: false,
                        maxTicksLimit: 5
                        //padding: 20
                      },
                      gridLines: {
                        drawBorder: false,
                        zeroLineColor: "transparent",
                        color: "rgba(255,255,255,0.05)"
                      }
                    }
                  ],

                  xAxes: [
                    {
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(255,255,255,0.1)",
                        zeroLineColor: "transparent",
                        display: false
                      },
                      ticks: {
                        padding: 20,
                        fontColor: "#9f9f9f"
                      }
                    }
                  ]
                }
              }
            };
            this.insightsLoaded = true;
            this.followerChart = {
              labels: followerLabels,
              datasets: [
                {
                  label: "followers",
                  borderColor: "#f17e5d",
                  pointBackgroundColor: "#f17e5d",
                  pointBackgroundColor: "#f17e5d",
                  pointRadius: 3,
                  pointHoverRadius: 3,
                  lineTension: 0,
                  fill: false,
                  borderWidth: 3,
                  data: followerData
                }
              ],
              color: "#f17e5d",
              options: {
                tooltips: tooltipOptions,
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        fontColor: "#9f9f9f",
                        beginAtZero: false,
                        maxTicksLimit: 3,
                        minTicksLimit: 1
                      },
                      gridLines: {
                        lineWidth: 1,
                        zeroLineColor: "transparent",
                        color: "#FAFAFA"
                        /*display: false
                      /*drawBorder: false,
                      borderDash: [8, 5],
                      "*/
                      }
                    }
                  ],

                  xAxes: [
                    {
                      barPercentage: 1.6,
                      gridLines: {
                        display: false

                        /*drawBorder: false,
                      borderDash: [8, 5],
                      color: "#9f9f9f",
                      zeroLineColor: "transparent"*/
                      },
                      ticks: {
                        padding: 20,
                        fontColor: "#9f9f9f"
                      }
                    }
                  ]
                }
              }
            };
            this.followersLoaded = true;
            this.websiteClicksChart = {
              labels: websiteClickLabels,
              datasets: [
                {
                  label: "Website Clicks",
                  borderColor: "#f17e5d",
                  pointBackgroundColor: "#f17e5d",
                  pointRadius: 3,
                  pointHoverRadius: 3,
                  lineTension: 0,
                  fill: false,
                  borderWidth: 3,
                  data: websiteClickData
                }
              ],
              color: "#f17e5d",
              options: {
                tooltips: tooltipOptions,
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        fontColor: "#9f9f9f",
                        beginAtZero: false,
                        maxTicksLimit: 3,
                        minTicksLimit: 1
                      },
                      gridLines: {
                        lineWidth: 1,
                        zeroLineColor: "transparent",
                        color: "#FAFAFA"
                        /*display: false
                      /*drawBorder: false,
                      borderDash: [8, 5],
                      "*/
                      }
                    }
                  ],

                  xAxes: [
                    {
                      barPercentage: 1.6,
                      gridLines: {
                        display: false

                        /*drawBorder: false,
                      borderDash: [8, 5],
                      color: "#9f9f9f",
                      zeroLineColor: "transparent"*/
                      },
                      ticks: {
                        padding: 20,
                        fontColor: "#9f9f9f"
                      }
                    }
                  ]
                }
              }
            };
            //     console.log("WEBSITE CLICKS CHART DATA: ", this.websiteClicksChart);
            this.websiteClicksChartLoaded = true;
            this.profileVisitsChart = {
              labels: profileVisitsLabels,
              datasets: [
                {
                  label: "Profile Visits",
                  borderColor: "#f17e5d",
                  pointBackgroundColor: "#f17e5d",
                  pointRadius: 3,
                  pointHoverRadius: 3,
                  lineTension: 0,
                  fill: false,
                  borderWidth: 3,
                  data: profileVisitsData
                }
              ],
              color: "#f17e5d",
              options: {
                tooltips: tooltipOptions,
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        fontColor: "#9f9f9f",
                        beginAtZero: false,
                        maxTicksLimit: 3,
                        minTicksLimit: 1
                      },
                      gridLines: {
                        lineWidth: 1,
                        zeroLineColor: "transparent",
                        color: "#FAFAFA"
                        /*display: false
                      /*drawBorder: false,
                      borderDash: [8, 5],
                      "*/
                      }
                    }
                  ],

                  xAxes: [
                    {
                      barPercentage: 1.6,
                      gridLines: {
                        display: false

                        /*drawBorder: false,
                      borderDash: [8, 5],
                      color: "#9f9f9f",
                      zeroLineColor: "transparent"*/
                      },
                      ticks: {
                        padding: 20,
                        fontColor: "#9f9f9f"
                      }
                    }
                  ]
                }
              }
            };
            this.profileVisitsChartLoaded = true;

            if (
              typeof instagramAnalyticsResponse.data.result.demographics
                .audienceGenderAge !== "undefined"
            ) {
              // GENDER BREAKDOWN
              let genderTypeLabels = instagramAnalyticsResponse.data.result.demographics.audienceGenderAge.labels.gender.map(
                x => {
                  if (x == "F") {
                    return "Female";
                  }
                  if (x == "M") {
                    return "Male";
                  }
                  if (x == "U") {
                    return "Unknown";
                  }
                }
              );
              let genderData = instagramAnalyticsResponse.data.result.demographics.audienceGenderAge.summary.gender.map(
                x => {
                  return x.count;
                }
              );

              //console.log("GENDER DATA:", genderData);

              this.genderSummaryApex = {};
              this.genderSummaryApex.options = {
                series: genderData,
                chart: {
                  id: "Follower-Gender-Data",
                  width: 380,
                  type: "pie",
                  legend: {
                    position: "bottom"
                  }
                },
                dataLabels: {
                  enabled: true,

                  dropShadow: {
                    enabled: false
                  }
                },
                labels: genderTypeLabels,
                responsive: [
                  {
                    breakpoint: 480,
                    options: {
                      chart: {
                        width: 200
                      },
                      legend: {
                        position: "bottom"
                      }
                    }
                  }
                ]
              };

              this.genderSummaryChart = {
                labels: genderTypeLabels,
                datasets: [
                  {
                    label: "Gender",
                    pointRadius: 0,
                    pointHoverRadius: 5,
                    backgroundColor: ["#4acccd", "#fcc468", "#e3e3e3"],
                    borderWidth: 0,
                    data: genderData
                  }
                ],
                options: {
                  chartPadding: 30,
                  labelOffset: 50,
                  labelDirection: "explode"
                }
              };

              // GENDER BREAKDOWN
              let ageTypeLabels =
                instagramAnalyticsResponse.data.result.demographics
                  .audienceGenderAge.labels.age;
              let ageData = instagramAnalyticsResponse.data.result.demographics.audienceGenderAge.summary.age.map(
                x => {
                  return x.count;
                }
              );

              //console.log("AGE DATA:", ageData);

              this.ageSummaryApex = {};
              this.ageSummaryApex.options = {
                chart: {
                  id: "Follwers-Age"
                },
                xaxis: {
                  categories: ageTypeLabels
                },
                plotOptions: {
                  bar: {
                    horizontal: true
                  }
                },
                dataLabels: {
                  enabled: false
                }
              };
              this.ageSummaryApex.series = [
                {
                  name: "total",
                  data: ageData
                }
              ];

              this.ageSummaryChart = {
                labels: ageTypeLabels,
                datasets: [
                  {
                    label: "AGe",
                    pointRadius: 0,
                    pointHoverRadius: 5,
                    backgroundColor: ["#fcc468", "#4acccd", "#e3e3e3"],
                    borderWidth: 0,
                    data: ageData
                  }
                ],
                options: {
                  chartPadding: 30,
                  labelOffset: 50,
                  labelDirection: "explode"
                }
              };
              this.countryChart = {};
              this.countryChart.data = [["Country", "Followers"]];
              let countryDataFormat = instagramAnalyticsResponse.data.result.demographics.audienceCountry.map(
                x => {
                  //console.log(x);
                  let countryArray = [];
                  countryArray[0] = x.country;
                  countryArray[1] = x.count;
                  return countryArray;
                }
              );
              //console.log("FORMATTED COUNTRY DATA:", countryDataFormat);
              this.countryChart.data = this.countryChart.data.concat(
                countryDataFormat
              );
              this.countryChart.options = {};
              //console.log("COUNTRY DATA", this.countryChart.data);
            }
          } else {
            this.noInstagramAnalytics = true;
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async formatDate(dateInput) {
      let thisDate = moment(dateInput).format("yyyy-MM-DD");
      console.log("THIS DATE:", thisDate);
    },
    async fullContentAnalyticsButton() {
      let dateQuery = "";
      if (typeof this.$route.query.start !== "undefined") {
        let startDateUrl = this.$route.query.start;
        dateQuery = `?start=${startDateUrl}`;
      }
      if (typeof this.$route.query.end !== "undefined") {
        let endDateUrl = this.$route.query.end;
        if (dateQuery == "") {
          dateQuery = `?end=${endDate}`;
        } else {
          dateQuery = dateQuery + `&end=${endDateUrl}`;
        }
      }
      this.$router.push(
        `/instagram/analytics/content/${this.$route.params.instagram}/${dateQuery}`
      );
    },
    async resetDates() {
      //console.log("START DATE", this.pickerStart);
      let startDateString = new Date(this.pickerStart); // Your timezone!
      this.startDate = startDateString.getTime() / 1000;
      //console.log("START TIMESTAMP: ", this.startDate);
      //console.log("END DATE", this.pickerEnd);
      let endDateString = new Date(this.pickerEnd); // Your timezone!
      this.endDate = endDateString.getTime() / 1000;
      //console.log("END TIMESTAMP: ", this.endDate);
      if (this.startDate < this.endDate) {
        let startDateUrl = moment
          .unix(this.startDate)
          .startOf("day")
          .format("YYYY-MM-DD");
        let endDateUrl = moment
          .unix(this.endDate)
          .endOf("day")
          .format("YYYY-MM-DD");
        this.analyticsData = null;
        await this.loadProfileAnalytics();
        await this.loadPostAnalytics();
        if (
          startDateUrl == this.$route.query.start &&
          endDateUrl == this.$route.query.end
        ) {
          return;
        }

        this.$router.push(
          `/instagram/analytics/all/${this.$route.params.instagram}/?start=${startDateUrl}&end=${endDateUrl}`
        );
      }
    },
    async loadRecentPosts() {
      try {
        let instagramPostResponse = await axios.get(
          `${instagramPostApi}/?usertoken=${this.auth}&instagram=${this.activeInstagram}`
        );

        //console.log("POST LIST :", instagramPostResponse.data);

        if (instagramPostResponse.data.success === true) {
          //console.log("SETTING POST LIST:");

          this.postList = instagramPostResponse.data.result.slice(0, 7);
          //this.filterList("feed");
          //console.log("POST LIST SET:", this.postList);
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadMentionPosts() {
      try {
        if (
          this.activeInstagram !== null &&
          this.activeInstagram !== "undefined"
        ) {
          let mentionPostUrl = `${fbGraphMentionPosts}/?usertoken=${this.auth}&instagram=${this.activeInstagram}`;
          //console.log("HERE IS THE MENTION POST URL: ", mentionPostUrl);
          let mentionPostResponse = await axios.get(mentionPostUrl);
          //   console.log(mentionPostResponse.data);
          if (mentionPostResponse.data.success == true) {
            this.mentionPostList = mentionPostResponse.data.result.tags.slice(
              0,
              7
            );
            this.mentionsLoaded = true;
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadInfluencerPosts() {},
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (
          this.relatedProfileStore == null ||
          typeof this.relatedProfileStore == "undefined"
        ) {
          let relatedProfileUrl = `${userRelatedProfilesApi}/?usertoken=${this.auth}`;
          //console.log("RELATED PROFILE URL:", relatedProfileUrl);
          let relatedProfileResponse = await axios.get(relatedProfileUrl);
          this.relatedProfiles = relatedProfileResponse.data.result;
          store.dispatch(
            "storeRelatedProfiles",
            relatedProfileResponse.data.result
          );
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async setProfileType() {
      //console.log("PROFILE STORE:", this.profileStore);
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },

    async loadPageContent() {
      await this.setProfileType();
      await this.getRelatedProfiles();
      this.getTime = await timeVars.timeInfo();
      //console.log("UTC TIME:", this.getTime.utcTime);

      this.endDate =
        moment
          .unix(this.getTime.utcTime)
          .startOf("day")
          .utc() / 1000;
      this.startDate =
        moment
          .unix(this.endDate)
          .utc()
          .subtract(7, "days") / 1000;

      //console.log("GENERIC START DATE:", this.startDate);
      //console.log("GENERIC END DATE:", this.endDate);

      this.pickerStart = new Date(this.startDate * 1000);
      if (typeof this.$route.query.start !== "undefined") {
        let startTs =
          moment(this.$route.query.start)
            .utc()
            .valueOf() / 1000;
        //console.log("START TS:", startTs);
        if (!isNaN(startTs)) {
          this.startDate = startTs;
          this.pickerStart = new Date(startTs * 1000);
          //console.log("PICKER START:", this.pickerStart);
        }
      }
      this.pickerEnd = new Date(this.endDate * 1000);
      if (typeof this.$route.query.end !== "undefined") {
        let endTs =
          moment(this.$route.query.end)
            .utc()
            .valueOf() / 1000;
        //console.log("END TS:", endTs);
        if (!isNaN(endTs)) {
          this.endDate = endTs;
          this.pickerEnd = new Date(this.endDate * 1000);
          //console.log("PICKER END:", this.pickerEnd);
        }
      }

      if (this.isClient == true) {
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }
      if (this.isInfluencer == true) {
        if (this.relatedProfiles !== null) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }

      if (this.isTeam == true) {
        this.activeInstagram = this.$route.params.instagram;
      }

      await this.checkNoAuthProfiles();

      //console.log("LINKED INSTAGRAM:", this.instagramLinked);
      if (this.instagramLinked == true) {
        this.loadProfileAnalytics();
        this.loadPostAnalytics();
        this.loadMentionPosts();
      }
      await this.loadRecentPosts();
      this.loadingOverlay = false;
    }
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  }
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
</style>